import { useState } from "react";
import { cdgiFAQs } from "./constant";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "./computer_science_and_engineering.css";

const Faq = () => {
  const [isOpen, setIsOpen] = useState("-1");

  return (
    <div className="mt-4 faq-container" style={{ maxWidth: "700px" }}>
      <p className="text-start fw-bold fs-5 mb-4 text-dark">
        Frequently Asked Questions (FAQs)
      </p>

      {cdgiFAQs.map(({ index, question, answer }) => (
        <div key={index} className="mb-3 p-3 border rounded bg-light">
          <div
            className="d-flex align-items-center fw-bold"
            role="button"
            style={{ cursor: "pointer" }}
            onClick={() =>
              setIsOpen(isOpen === String(index) ? "-1" : String(index))
            }
          >
            <span className="fw-bolder me-2 text-primary">Q{index}.</span>
            <h5 className="mb-0 flex-grow-1 fs-6 container-title-h4">{question}</h5>

            <span>
              {isOpen === String(index) ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </span>
          </div>

          <div
            className="mt-2 overflow-hidden"
            style={{
              maxHeight: isOpen === String(index) ? "500px" : "0px",
              opacity: isOpen === String(index) ? 1 : 0,
              transform:
                isOpen === String(index)
                  ? "translateY(0)"
                  : "translateY(-10px)",
              transition: "all 0.5s ease",
            }}
          >
            {isOpen === String(index) && (
              <p className="mt-2 mb-0 text-secondary">{answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
